<template>
  <div>
    <el-tag
      :type="type"
      :size="size"
      :key="tag"
    v-for="tag in dynamicTags"
      closable
      :disable-transitions="false"
      :disabled="disabled"
      @close="handleClose(tag)">
      {{tag}}
  </el-tag>

  <el-input
    class="input-new-tag"
    v-if="inputVisible"
    v-model="form"
    ref="saveTagInput"
    :size="size"
    @keyup.enter.native="handleInputConfirm"
    @blur="handleInputConfirm">
</el-input>

<el-button v-else class="button-new-tag" size="small" @click="showInput">+ New {{tagLabel}}</el-button>

</div>
</template>


<script>

export default {
  name: 'tag-input',

  props: {
    value: {
      required: true
    },

    tagLabel: {
      type: String,
      default: 'Tag'
    },

    size: {
      type: String,
      default: 'default',
      validator: function (value) {
        // The value must match one of these strings
        return ['default', 'medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },

    type: {
      type: String,
      default: 'info',
      validator: function (value) {
        // The value must match one of these strings
        return ['success', 'info', 'warning', 'danger'].indexOf(value) !== -1
      }
    },

    disabled: {
      type: Boolean,
      default: false
    }

  },

  methods: {

    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput () {
      this.inputVisible = true

      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm () {
      let inputValue = this.inputValue

      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }

      this.inputVisible = false
      this.inputValue = ''
    },

    updated (value) {
      this.form = value
//      console.log('tag-input', value, 'dynamicTags', this.dynamicTags)
      this.$emit('input', this.form)
      this.$emit('change', this.form)
    }
  },

  data () {
    return {
      dynamicTags: [],
      inputVisible: false,
      form: ''
    }
  }
}
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// TagInput.vue?3ddd6db2